import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppPaymentPage } from './app-payment';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {CommonModule} from "@angular/common";

@NgModule({
  declarations: [
    AppPaymentPage,
  ],
    imports: [
        IonicPageModule.forChild(AppPaymentPage),
        PipesModule,
        DirectivesModule,
        CommonModule,

    ],
})
export class AppPaymentPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-payment/app-payment.module.ts